<template>
  <div id="app" :class="{'isMobile': $device.isMobile}">
    <!-- <Loader/> -->
    <div class="BetaBanner" ref="betab">
      <img src="./assets/icons/beta.svg" alt="version beta">
    </div>
    <Counter :women="this.women"/>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>

    <About ref="about" :data="about" :outclose="onCloseAbout"/>
    <Tutorial ref="tuto" :data="tuto" />

    <footer ref="footer">
      <a class="Footer-button" href="https://stop-violences-femmes.gouv.fr/" target="_blank">3919 violences femmes infos</a>
      <div class="Footer-figures Footer-figures--detailed" v-for="(k, i) in killings" :key="i">
        {{2017 + i}} : {{k}} Féminicides
      </div>
      <div class="Footer-figures Footer-figures--merged">
        Depuis 2017 : {{totalKillings}} Féminicides
      </div>
      <a target="_blank" :class="{'active': isAbout}" @click="onClickAbout" ref="aboutbtn">
        À propos
        <div class="tick" v-show="isAbout"></div>
      </a>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
// import EventBus from '@/utils/event-bus'

// import Counter from '@/components/Counter.vue'
// import Loader from '@/components/Loader.vue'
// import About from '@/components/About.vue'
// import Tutorial from '@/components/Tutorial.vue'
import gsap from 'gsap'

const About = () => import('@/components/About.vue')
const Tutorial = () => import('@/components/Tutorial.vue')
const Counter = () => import('@/components/Counter.vue')

export default {
  name: 'App',
  components: {
    Counter,
    // Loader,
    About,
    Tutorial
  },
  metaInfo () {
    return {
      meta: [
      ]
    }
  },
  data () {
    return {
      women: [],
      killings: [],
      totalKillings: 0,
      isAbout: false,
      tlShow: null,
      about: {
        title: '',
        presentation: '',
        sources: '',
        credits: ''
      },
      tuto: {
        title: '',
        steps: []
      },
      meta: {
        title: '',
        desc: '',
        image: ''
      }
    }
  },
  beforeDestroy () {
    if (this.tlShow) this.tlShow.kill()
  },
  async created () {
    // console.log('CREATED')
    if (this.$device.isMobile) document.body.classList.add('isMobile')
    await this.getContent()
    // console.log('END')
  },
  mounted () {
    this.show()
  },
  methods: {
    async getContent () {
      await this.getMetaData()
      await this.getAssetsData()
    },
    async getAssetsData () {
      const bgs = await this.getBackgroundsFromAPI()
      const data = {
        backgrounds: [],
        sentences: []
      }
      bgs.forEach(r => {
        data.backgrounds.push({
          uid: r.uid,
          title: r.data.title,
          url: r.data.image.url
        })
      })

      const sts = await this.getSentencesFromAPI()
      sts.forEach(r => {
        data.sentences.push({
          uid: r.uid,
          url: r.data.image.url
        })
      })

      this.$store.commit('SET_ASSETS', data)
    },
    async getMetaData () {
      const { data } = await this.$prismic.client.getSingle('meta')
      // console.log(data)
      // end preload
      this.women = data.women
      this.killings.push(data.feminicides_2017)
      this.killings.push(data.feminicides_2018)
      this.killings.push(data.feminicides_2019)
      this.killings.forEach(k => {
        this.totalKillings += k
      })
      this.totalKillings += this.women.length

      this.about = {
        title: data.about_title,
        presentation: data.about_presentation,
        sources: data.about_sources,
        credits: data.about_credits
      }

      this.tuto = {
        title: data.tuto_title,
        steps: [
          { title: data.tuto_step_1_title, text: data.tuto_step_1_text },
          { title: data.tuto_step_2_title, text: data.tuto_step_2_text },
          { title: data.tuto_step_3_title, text: data.tuto_step_3_text }
        ]
      }

      this.meta = {
        title: data.meta_title,
        desc: data.meta_description,
        image: data.meta_image.url
      }

      this.changeFavicon()

      this.$store.commit('SET_TEXTES', {
        mainTitle: data.main_title,
        previewTitle: data.preview_title
      })
    },
    async getBackgroundsFromAPI () {
      /* TODO: externalise? */
      const { results } = await this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'background'),
        {
          orderings: '[document.last_publication_date desc]',
          pageSize: 100
        }
      )
      return results
    },
    async getPrivateSentencesFromAPI (code) {
      /* TODO: externalise? */
      const { results } = await this.$prismic.client.query(
        this.$prismic.Predicates.any('my.sentence.private_code', [code]),
        {
          orderings: '[document.last_publication_date desc]',
          pageSize: 100
        }
      )
      return results
    },
    async getSentencesFromAPI () {
      const { results } = await this.$prismic.client.query(
        [
          this.$prismic.Predicates.at('document.type', 'sentence'),
          this.$prismic.Predicates.missing('my.sentence.private_code')
        ],
        {
          orderings: '[document.last_publication_date desc]',
          pageSize: 100
        }
      )
      return results
    },
    changeFavicon () {
      var favicon = document.querySelector("link[rel*='icon']") || document.createElement('link')
      var faviconSize = 32

      var canvas = document.createElement('canvas')
      canvas.width = faviconSize
      canvas.height = faviconSize

      var context = canvas.getContext('2d')
      var img = document.createElement('img')
      img.src = favicon.href

      img.onload = () => {
        // Draw Original Favicon as Background
        // context.drawImage(img, 0, 0, faviconSize, faviconSize)

        // Draw Notification Circle
        context.beginPath()
        context.arc(canvas.width - faviconSize / 2, faviconSize / 2, faviconSize / 2, 0, 2 * Math.PI)
        context.fillStyle = '#FF0000'
        context.fill()

        // Draw Notification Number
        context.font = '18px "LeagueMonoBold", sans-serif'
        context.textAlign = 'center'
        context.textBaseline = 'middle'
        context.fillStyle = '#FFFFFF'
        context.fillText(this.women.length, canvas.width - faviconSize / 2, faviconSize / 2)

        // Replace favicon
        favicon.href = canvas.toDataURL('image/png')
      }
    },
    onClickAbout (e) {
      if (this.isAbout) return
      this.isAbout = true
      this.$refs.about.open()
      document.body.style.overflowY = 'hidden'
      document.body.style.overflowX = 'hidden'
    },
    onCloseAbout (e) {
      if (e.target === this.$refs.aboutbtn) return
      this.$refs.about.close()
      this.isAbout = false
      document.body.style.overflowY = this.$device.isMobile ? 'auto' : 'hidden'
    },
    show () {
      this.tlShow = gsap.timeline()
      this.tlShow.fromTo(this.$refs.betab, { xPercent: -100 }, { duration: 0.4, alpha: 1, xPercent: 0, ease: 'expo.out' }, 1.6)
      this.tlShow.fromTo(this.$refs.footer, { yPercent: 100 }, { duration: 0.4, alpha: 1, yPercent: 0, ease: 'expo.out' }, 1.4)
    }
  }
}
</script>

<style lang="stylus">
// @import './styles/fonts.styl'
dark-color = #1b1b1b

body
  width 100%
  height 100%
  background dark-color
  overflow-x hidden
  overflow-y auto

body:not(.isMobile)
  overflow-x hidden
  overflow-y hidden

#app
  // @extends .font-default
  font-family LeagueMono, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  // text-align center
  color #2c3e50
  width 100%
  height 100%
  position relative
  // height 100%
  .BetaBanner
    position absolute
    top 39px
    left 0
    z-index 100
    opacity 0
    img
      display block
      width 100px

  footer
    position relative
    z-index 100
    border-top 1px solid white
    display table
    width 100%
    justify-content space-between
    color white
    opacity 0
    .Footer-button
      color red
      width 320px
      font-family 'LeagueMonoBold'
      transition all 200ms linear
      background white
      &:hover
        color white
        background red
    > div
    > a
      padding 12px
      display table-cell
      text-transform uppercase
      text-decoration none
      transition all 200ms linear
      border-right 1px solid white
      text-align center
      white-space nowrap
    > a
      background white
      color black
      cursor pointer
      font-family 'LeagueMonoBold'
      &.active
        color white
        background #1b1b1b
        position relative
        .tick
          position absolute
          background #1b1b1b
          width 10px
          height 10px
          transform rotate(45deg)
          transform-origin center center
          top -5px
          left 0
          right 0
          margin auto
          z-index 5
      &:hover
        color red
    .Footer-figures--merged
      display none

@media(max-width: 1090px)
  #app
    footer
      font-size 0.95rem
@media(max-width: 1024px)
  #app
    footer
      .Footer-figures--detailed
        display none
      .Footer-figures--merged
        display block

@media(max-width: 670px)
  html
  body
    overflow-x hidden
  body
    position relative
  #app
    .BetaBanner
      top 28px
      img
        width 60px
    footer
      .Footer-figures
        display none
      a
        font-size 0.8rem
        white-space nowrap
        border-right 1px solid black
        border-left 1px solid black
        border-top 1px solid black

@media screen and (max-width:670px) and (orientation:landscape)
  #app
    footer
    .About
      display none
</style>
